import { message } from 'antd';

export async function fetchWithLoading<T>(
  fetchFn: () => Promise<T>,
  setLoading: (v: boolean) => void,
  setData: (data: T) => void,
  errorMsg: string
) {
  setLoading(true);
  try {
    const data = await fetchFn();
    setData(data);
  } catch {
    message.error(errorMsg);
  } finally {
    setLoading(false);
  }
} 